// face_emotion_detection Redux reducer
import ReducerRegistry from '../base/redux/ReducerRegistry';
import { SET_FACE_EMOTION_DETECTION_VISIBLE, SET_FACE_EMOTION_DETECTION_ENABLED, SET_FACE_EMOTION_DETECTION_DETECTING, SET_CURRENT_FACE_DATA, SET_FACE_EMOTION_DETECTION_ERROR } from './actions';
const DEFAULT_STATE = {
    visible: false,
    enabled: false,
    detecting: false,
    currentFaceData: null,
    error: null
};
ReducerRegistry.register('features/face_emotion_detection', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_FACE_EMOTION_DETECTION_VISIBLE:
            return {
                ...state,
                visible: action.visible
            };
        case SET_FACE_EMOTION_DETECTION_ENABLED:
            return {
                ...state,
                enabled: action.enabled,
                detecting: action.enabled ? state.detecting : false
            };
        case SET_FACE_EMOTION_DETECTION_DETECTING:
            return {
                ...state,
                detecting: action.detecting
            };
        case SET_CURRENT_FACE_DATA:
            return {
                ...state,
                currentFaceData: action.faceData,
                error: null
            };
        case SET_FACE_EMOTION_DETECTION_ERROR:
            return {
                ...state,
                error: action.error,
                detecting: false
            };
        default:
            return state;
    }
});
